<template>
    <div v-if="collection">
        <div class="invest-target">
            <div class="display-flex mb12">
                <h4>{{$t('planner.TARGETS')}}</h4>
                <el-button
                    type="primary"
                    class="solid-btn"
                    @click="goTo"
                >{{$t('planner.EditTargets')}}</el-button>
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col :xs="24" :md="12">
                        <div class="allocation box-style">
                            <span
                                class="border-t"
                                :style="{width: collection.real_estate.percentage > 100 ? '100%': `${collection.real_estate.percentage}%`}"
                            ></span>
                            <h2>{{$t('planner.RealEstateAllocation')}}</h2>
                            <p
                                class="tar-val"
                            >{{$t('planner.TargetValue')}} {{collection.currency_symbol}}{{collection.real_estate.target | NumFormatToFixed}}</p>
                            <el-row>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p class="tar-title">{{$t('planner.CurrentEquilty')}}</p>
                                        <p
                                            class="tar-num"
                                        >{{collection.currency_symbol}}{{collection.real_estate.current | NumFormatToFixed}}</p>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p
                                            class="tar-title"
                                        >{{translations(collection.real_estate.type)}}</p>
                                        <p
                                            class="tar-num"
                                            :class="collection.real_estate.type"
                                        >{{collection.currency_symbol}}{{collection.real_estate.difference | NumFormatToFixed}}</p>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p class="tar-title">{{$t('planner.TargetAchieved')}}</p>
                                        <p
                                            class="tar-num"
                                        >{{collection.real_estate.percentage | NumFormat}}%</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :xs="24" :md="12">
                        <div class="cash-flow box-style">
                            <span
                                class="border-t"
                                :style="{width: collection.cash_flow.percentage > 100 ? '100%': `${collection.cash_flow.percentage}%`}"
                            ></span>
                            <h2>{{$t('planner.CashFlow')}}</h2>
                            <p
                                class="tar-val"
                            >{{$t('planner.TargetValue')}} {{collection.currency_symbol}}{{collection.cash_flow.target | NumFormatToFixed}}</p>
                            <el-row>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p class="tar-title">{{$t('planner.CurrentCashFlow')}}</p>
                                        <el-tooltip class="item" effect="dark" placement="bottom">
                                            <div slot="content">
                                                <span
                                                    class="tar-tooltip"
                                                >{{$t('planner.RealEstate')}}: {{collection.real_estate_cash_flow | NumFormatToFixed}}</span>
                                                <br />
                                                <span
                                                    class="tar-tooltip"
                                                >{{$t('planner.AllOther')}}: {{collection.other_cash_flow | NumFormatToFixed}}</span>
                                            </div>
                                            <p
                                                class="tar-num"
                                            >{{collection.currency_symbol}}{{collection.cash_flow.current | NumFormatToFixed}}</p>
                                        </el-tooltip>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p
                                            class="tar-title"
                                        >{{translations(collection.cash_flow.type)}}</p>
                                        <p
                                            class="tar-num surplus"
                                            :class="collection.cash_flow.type"
                                        >{{collection.currency_symbol}}{{collection.cash_flow.difference | NumFormatToFixed}}</p>
                                    </div>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <div>
                                        <p class="tar-title">{{$t('planner.TargetAchieved')}}</p>
                                        <p
                                            class="tar-num"
                                        >{{collection.cash_flow.percentage | NumFormat}}%</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="invest-portfolio">
            <h4>{{$t('planner.RETIREMENTPROPERTYPORTFOLIO')}} ({{savings.currency_symbol}})</h4>
            <div class="display-flex existing-invest">
                <div class="target-title">{{$t('planner.EXISTINGINVESTMENTS')}}</div>
                <el-button
                    type="primary"
                    class="target-addProp"
                    @click="addProp"
                >+ {{$t('planner.AddProperty')}}</el-button>
            </div>
            <el-table
                :data="existingCities"
                style="width: 100%"
                :empty-text="$t('cityRanking.noResult')"
                header-cell-class-name="exist_h-row-style"
                cell-class-name="exist-row-style"
            >
                <el-table-column :label="$t('planner.Name')" min-width="140px">
                    <template slot-scope="scope">
                        <img :src="scope.row.flag" alt="country icon" class="flag_icon" />
                        <span :title="scope.row.name">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="right"
                    :label="$t('planner.CurrentValue')"
                    min-width="110px"
                >
                    <template
                        slot-scope="scope"
                    >{{savings.currency_symbol}}{{scope.row.amount | NumFormat}}</template>
                </el-table-column>
                <el-table-column align="right" :label="$t('planner.GrossYield')">
                    <template slot-scope="scope">
                        <span class="target-yield">{{scope.row.yield}}%</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" min-width="100px">
                    <template slot="header" slot-scope="scope">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content">
                                <span>{{$t('planner.MortgageFree')}}</span>
                            </div>
                            <span class="info">
                                <span>{{$t('planner.AnnualCashFlow')}}</span>
                            </span>
                        </el-tooltip>
                    </template>
                    <template
                        slot-scope="scope"
                    >{{savings.currency_symbol}}{{scope.row.cash_flow | NumFormat}}</template>
                </el-table-column>
                <el-table-column align="right" min-width="140px">
                    <template slot-scope="scope">
                        <a
                            @click="linkToPID(scope.row)"
                            class="target-viewD"
                        >{{$t('planner.ViewDetails')}}</a>
                    </template>
                </el-table-column>
            </el-table>

            <el-table
                :data="targetCities"
                show-summary
                :summary-method="getSummaries"
                style="width: 100%"
                :empty-text="$t('cityRanking.noResult')"
                header-cell-class-name="target_h-row-style"
                cell-class-name="target-row-style"
            >
                <el-table-column min-width="140px">
                    <template slot="header" slot-scope="scope">
                        <span class="target-title">{{$t('planner.TARGETCITIES')}}</span>
                    </template>
                    <template slot-scope="scope">
                        <img :src="scope.row.flag" alt="country icon" class="flag_icon" />
                        <span :title="scope.row.name">{{scope.row.name}}</span>
                    </template>
                </el-table-column>

                <el-table-column align="right" min-width="110px">
                    <template
                        slot-scope="scope"
                    >{{savings.currency_symbol}}{{scope.row.amount | NumFormat}}</template>
                </el-table-column>
                <el-table-column align="right">
                    <template slot-scope="scope">
                        <span class="target-yield">{{scope.row.yield}}%</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" min-width="110px">
                    <template
                        slot-scope="scope"
                    >{{savings.currency_symbol}}{{scope.row.cash_flow | NumFormat}}</template>
                </el-table-column>
                <el-table-column align="right" min-width="140px">
                    <template slot="header" slot-scope="scope">
                        <el-button
                            type="primary"
                            class="target-addProp hidden-sm-and-down"
                            @click="addTarget"
                        >+ {{$t('planner.AddTargetCity')}}</el-button>
                    </template>
                    <template slot-scope="scope">
                        <span
                            class="target-delete"
                            @click="deleteTar(scope.row)"
                        >{{$t('planner.Delete')}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-button
                type="primary"
                class="target-addProp hidden-md-and-up xs-block"
                @click="addTarget"
            >+ {{$t('planner.AddTargetCity')}}</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "investStrategy",
    props: ["collection", "savings"],
    data() {
        const $t = this.$t.bind(this);
        return {
            existingCities: [],
            targetCities: []
        };
    },
    beforeMount() {
        this.targetCities = this.collection.ideal_investments;
        this.existingCities = this.collection.existing_investments;
    },

    mounted() {},

    methods: {
        translations(val) {
            if (val == "SURPLUS") {
                return this.$t("planner.SURPLUS");
            } else if (val == "SHORTFALL") {
                return this.$t("planner.SHORTFALL");
            }
        },

        getSummaries(param) {
            // const { columns, data } = param;
            let sums = [];
            sums = [
                `${this.$t("planner.Total")} (${
                    this.collection.currency_code
                })`,
                `${this.collection.currency_symbol} ${this.NumFormat(
                    this.collection.total_properties_amount
                )}`,
                "",
                `${this.collection.currency_symbol} ${this.NumFormat(
                    this.collection.total_properties_cash_flow
                )}`,
                ""
            ];
            return sums;
        },

        deleteTar(obj) {
            this.$emit("deleteTar", obj);
        },

        linkToPID(obj) {
            this.$emit("linkToPID", obj);
        },

        addProp(obj) {
            this.$emit("addProperty", "");
        },

        addTarget(obj) {
            this.$emit("goTo", "addTar");
        },

        goTo() {
            this.$emit("goTo", "editTar");
        },

        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    watch: {
        collection: {
            handler(newVal, oldVal) {
                this.targetCities = newVal.ideal_investments;
                this.existingCities = newVal.existing_investments;
            },
            deep: true
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        NumFormatToFixed: function(val) {
            if (!val) return "0";
            return val
                .toFixed()
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        FirstCapital: function(val) {
            return val.toLowerCase();
        }
    },

    components: {}
};
</script>

<style lang="scss">
.invest-target {
    border-radius: 4px;
    border: solid 1px #e6e6e6;
    background-color: #f2f7ff;
    padding: 19px 20px;
    margin-bottom: 20px;
    .box-style {
        border-radius: 4px;
        border: solid 1px #e6e6e6;
        background-color: var(--white);
        padding: 25px 16px;
        @media (max-width: 414px) {
            padding-bottom: 0;
        }
        position: relative;

        @media (max-width: 768px) {
            &:last-child {
                margin-top: 20px;
            }
        }
        .border-t {
            display: inline-block;
            position: absolute;
            left: 0;
            top: 0;
            transition: all 0.3s ease;
            height: 5px;
            border-radius: 6px;
            background-color: #447ef6;
        }
        h2 {
            height: auto;
            line-height: normal;
            font-family: GothamMedium;
            margin-bottom: 8px;
            font-size: 14px;
            color: #333333;
        }
        .tar-val {
            line-height: normal;
            font-family: GothamBook;
            font-size: 11px;
            color: #666660;
            margin-bottom: 26px;
            @media (max-width: 414px) {
                margin-bottom: 13px;
            }
        }
        .tar-title {
            line-height: normal;
            font-family: GothamBook;
            margin-bottom: 7px;
            font-size: 11px;
            color: #666660;
            text-transform: capitalize;
            @media (max-width: 414px) {
                margin-bottom: 2px;
            }
        }

        .tar-num {
            line-height: normal;
            font-family: GothamMedium;
            font-size: 13px;
            color: #333333;
            word-break: break-word;
            @media (max-width: 414px) {
                margin-bottom: 10px;
            }
            &.SURPLUS {
                color: var(--windows-blue);
            }
            &.SHORTFALL {
                color: #bc3036;
            }
        }
    }
}
.display-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.existing-invest {
        height: 35px;
    }
    &.mb12 {
        margin-bottom: 12px;
    }
    .el-row {
        width: 100%;
    }
    h4 {
        font-family: GothamMedium;
        font-size: 12px;
        letter-spacing: 1.12px;
        color: #333333;
    }
    .solid-btn {
        padding-top: 0;
        padding-bottom: 0;
        text-align: center;
        box-shadow: none;
        font-family: GothamBook;
        font-size: 11px;
        color: var(--white);
        width: auto;
        height: 26px;
        line-height: 26px;
        border-color: transparent;
        border-radius: 2px;
        background-color: var(--windows-blue);
    }
}

.invest-portfolio {
    padding: 20px 18px;
    border-radius: 6px;
    box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
    border: solid 0.9px #e5edf3;
    background-color: var(--white);
    h4 {
        font-family: GothamMedium;
        font-size: 12px;
        color: #333333;
        margin-bottom: 20px;
    }
    .display-flex {
        display: flex;
        justify-content: space-between;
    }
    .target-title {
        font-family: GothamMedium;
        font-size: 12px;
        color: #333333;
    }
    .target-addProp {
        height: 26px;
        border-radius: 2px;
        background-color: var(--windows-blue);
        width: auto;
        border: none;
        font-family: GothamBook;
        font-size: 11px;
        color: var(--white);
        padding-top: 0;
        padding-bottom: 0;
        &.xs-block {
            font-family: GothamBook;
            font-size: 11px;
            color: var(--white);
            width: 100%;
            margin-top: 20px;
        }
        &:hover {
            background-color: var(--windows-blue);
        }
    }
    .el-table {
        .target_h-row-style {
            background-color: #f2f7ff;
            padding: 5px 0;
        }
        .el-table__header-wrapper {
            // overflow: visible;
        }
        .exist_h-row-style {
            background-color: #f6f9fc;
            padding: 5px 0;
            overflow: visible;
            .cell {
                overflow: visible;
                font-family: GothamMedium;
                font-size: 11px;
                color: var(--brownish-grey);
                word-break: break-word;
                .info {
                    position: relative;
                    padding-right: 10px;
                    &::after {
                        content: "";
                        cursor: pointer;
                        position: absolute;
                        right: -10px;
                        top: 0;
                        display: inline-block;
                        width: 11px;
                        height: 11px;
                        background: url("../../../../website_20/static/img/infoIcon@2x.png")
                            no-repeat;
                        background-size: cover;
                        @media (max-width: 414px) {
                            top: 24px;
                        }
                    }
                }
            }
        }
        .target-row-style {
            background-color: #f2f7ff;
            .cell {
                &,
                span {
                    font-family: GothamBook;
                    font-size: 13px;
                    color: #333333;
                    word-break: break-word;
                    @media (max-width: 414px) {
                        display: block;
                    }
                }
                .target-delete {
                    cursor: pointer;
                    font-family: GothamBook;
                    font-size: 11px;
                    color: #929292;
                    width: 100%;
                    text-align: center;
                    height: 23px;
                    line-height: 23px;
                    display: block;
                    &::before {
                        content: "";
                        display: inline-block;
                        width: 11px;
                        height: 12px;
                        margin-right: 6px;
                        margin-bottom: -1px;
                        background: url("../../../../website_20/static/img/manage/icon-bin.svg")
                            no-repeat;
                        background-size: cover;
                    }
                }
            }
            .target-yield {
                font-family: GothamMedium;
                color: var(--windows-blue);
            }
        }

        .exist-row-style {
            // background-color: #f2f7ff;
            .cell {
                &,
                span {
                    font-family: GothamBook;
                    font-size: 13px;
                    color: #333333;
                    word-break: break-word;
                    @media (max-width: 414px) {
                        display: block;
                    }
                }
                .target-viewD {
                    font-family: GothamBook;
                    font-size: 11px;
                    color: var(--windows-blue);
                    width: 100%;
                    text-align: center;
                    display: inline-block;
                    &::after {
                        content: ">";
                        display: inline-block;
                        position: absolute;
                        right: 23%;
                        color: var(--windows-blue);
                        font-family: GothamMedium;
                        margin-left: 6px;
                    }
                    @media (max-width: 414px) {
                        line-height: 1.1;
                        &::after {
                            right: 43%;
                            top: 50px;
                        }
                    }
                }
            }
            .target-yield {
                font-family: GothamMedium;
                color: var(--windows-blue);
            }
        }
        .flag_icon {
            width: 25px;
            height: 16px;
            object-fit: cover;
            border-radius: 2px;
            border: solid 0.8px #e4ecf3;
            margin-right: 10px;
        }
        &.targetTotal {
            .el-table__body-wrapper {
                display: none;
            }
        }
    }
    .el-table__footer-wrapper tbody {
        td {
            background-color: #f2f7ff;
            .cell {
                font-family: GothamMedium;
                font-size: 13px;
                font-weight: 500;
                color: #333333;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/investStrategy.vue